import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './RehabClinicsComponent.metadata.json5';
import styles from '../MedicalPractitioners.module.scss';

function RehabClinicsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RehabClinicsComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifNoPleDesProWhiDet11: {
            visible: !_.isUndefined(modelVM.value.isEacResAssUpoAdmTo10) && !modelVM.value.isEacResAssUpoAdmTo10
        },
        ifNoWhoPerTheRol17: {
            visible: !_.isUndefined(modelVM.value.doAllResHavTheOwnAtt16) && !modelVM.value.doAllResHavTheOwnAtt16
        },
        ifYesWheIsTheMetSto27: {
            visible: !_.isUndefined(modelVM.value.doYouProAMetMaiPro26) && modelVM.value.doYouProAMetMaiPro26
        },
        ifNoWheAreTheKep40: {
            visible: !_.isUndefined(modelVM.value.areAllMedAndEquKepIn39) && !modelVM.value.areAllMedAndEquKepIn39
        },
        ifYesSpe49: {
            visible: !_.isUndefined(modelVM.value.doYouProBloSamCol48) && modelVM.value.doYouProBloSamCol48
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RehabClinicsComponent.propTypes = wizardProps;
export default withRouter(RehabClinicsComponent);
